import { isCollectionDetailView } from '../../../helpers/windowLocation';
import { useIsHybridSearchEnabled } from '../HybridSearch/useIsHybridSearchEnabled';

type Options = {
	isNLSSearchOn: boolean;
	isPerformingNLSSearch: boolean;
};

export function useHybridSearchMode({ isNLSSearchOn, isPerformingNLSSearch }: Options) {
	const isHybridSearchEnabled = useIsHybridSearchEnabled();

	// Used in searchSpotlightAssets to decide which endpoint to use to get asset results in the dropdown.
	// The NLS/Hybrid toggle picks the endpoint, so Spotlight and the assetbank always agree: paramount
	// gets the same choice with each asset-bank/search event (localStorage on page load).
	const isHybridSearchOn = isHybridSearchEnabled && isNLSSearchOn;

	// Under hybrid search the AI toggle no longer applies a similarity filter to the assetbank: the term is
	// sent as a normal text/singletext filter and the hybrid endpoint blends the visual results in
	// itself. For portals not under the Hybrid PoC, this is exactly `isPerformingNLSSearch`, as before.
	const isApplyingSimilarityFilter = isPerformingNLSSearch && !isHybridSearchEnabled;

	// Hybrid returns dropdown results for the AI mode, which plain NLS never did — except inside a
	// collection, where there is no hybrid endpoint and today's behaviour stands.
	const isHybridDropdownActive = isHybridSearchOn && !isCollectionDetailView();

	// Suppresses everything that depends on the dropdown having searched: the fetch itself, the
	// results section and its skeletons, and the category chips.
	const isDropdownSearchDisabled = isPerformingNLSSearch && !isHybridDropdownActive;

	return {
		isHybridSearchEnabled,
		isHybridSearchOn,
		isApplyingSimilarityFilter,
		isDropdownSearchDisabled,
	};
}
